import { Type, type SchemaOptions } from '@sinclair/typebox';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_PRESTATION_TYPE = 'PRESTATION_TYPE_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum PrestationType
export enum PrestationType {
  STANDARD = 'STANDARD',
  RIDE = 'RIDE',
}

export const PrestationTypeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRESTATION_TYPE}${PrestationType.STANDARD}`]: 'Standard',
    [`${TRANSLATE_KEY_PRESTATION_TYPE}${PrestationType.RIDE}`]: 'Course',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(PrestationType, PrestationTypeTranslation, TRANSLATE_KEY_PRESTATION_TYPE, true);

export const PrestationTypeSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(PrestationType).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY_PRESTATION_TYPE}${value}`,
      }),
    ),
    options,
  );
};

export const TRANSLATE_KEY_PRESTATION_PAYMENT_TYPE = 'PRESTATION_PAYMENT_TYPE_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum PrestationPaymentType
export enum PrestationPaymentType {
  CARD_SAVE = 'CARD_SAVE',
  BANK_IMPRINT = 'BANK_IMPRINT',
  FULL_PAYMENT = 'FULL_PAYMENT',
  FULL_PAYMENT_OPTIONAL = 'FULL_PAYMENT_OPTIONAL',
  DEPOSIT = 'DEPOSIT',
  FREE = 'FREE',
}

export const PrestationPaymentTypeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRESTATION_PAYMENT_TYPE}${PrestationPaymentType.CARD_SAVE}`]: 'Sauvegarde de CB',
    [`${TRANSLATE_KEY_PRESTATION_PAYMENT_TYPE}${PrestationPaymentType.BANK_IMPRINT}`]: 'Empreinte bancaire',
    [`${TRANSLATE_KEY_PRESTATION_PAYMENT_TYPE}${PrestationPaymentType.FULL_PAYMENT}`]: 'Paiement intégral',
    [`${TRANSLATE_KEY_PRESTATION_PAYMENT_TYPE}${PrestationPaymentType.FULL_PAYMENT_OPTIONAL}`]:
      'Paiement intégral optionnel',
    [`${TRANSLATE_KEY_PRESTATION_PAYMENT_TYPE}${PrestationPaymentType.DEPOSIT}`]: 'Acompte',
    [`${TRANSLATE_KEY_PRESTATION_PAYMENT_TYPE}${PrestationPaymentType.FREE}`]: 'Aucun paiement requis',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  PrestationPaymentType,
  PrestationPaymentTypeTranslation,
  TRANSLATE_KEY_PRESTATION_PAYMENT_TYPE,
  true,
);

export const PrestationPaymentTypeSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(PrestationPaymentType).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY_PRESTATION_PAYMENT_TYPE}${value}`,
      }),
    ),
    options,
  );
};

export const TRANSLATE_KEY_PRESTATION_PAYMENT_AMOUNT_MODE = 'PRESTATION_PAYMENT_AMOUNT_MODE_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum PrestationPaymentAmountMode
// Calcul de l'acompte (DEPOSIT) ou des frais d'annulation tardive (autres types payants) d'une
// prestation : pourcentage du prix (`prestation.percentage`) ou montant fixe par unité facturée
// (`prestation.fixed_amount`, unités mineures). Cf. resolveFixedPaymentAmount (prestation-payment-amount.ts).
export enum PrestationPaymentAmountMode {
  PERCENTAGE = 'PERCENTAGE',
  FIXED_AMOUNT = 'FIXED_AMOUNT',
}

export const PrestationPaymentAmountModeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRESTATION_PAYMENT_AMOUNT_MODE}${PrestationPaymentAmountMode.PERCENTAGE}`]: 'Pourcentage du prix',
    [`${TRANSLATE_KEY_PRESTATION_PAYMENT_AMOUNT_MODE}${PrestationPaymentAmountMode.FIXED_AMOUNT}`]: 'Montant fixe',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  PrestationPaymentAmountMode,
  PrestationPaymentAmountModeTranslation,
  TRANSLATE_KEY_PRESTATION_PAYMENT_AMOUNT_MODE,
  true,
);

export const PrestationPaymentAmountModeSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(PrestationPaymentAmountMode).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY_PRESTATION_PAYMENT_AMOUNT_MODE}${value}`,
      }),
    ),
    options,
  );
};
